import React from "react";
import { Output } from "../../Text";
import { renderRadioGroup, SelectField, TextField } from "../../formik";
import { FastField } from "formik";
import toOptions from "../../functional/toOptions";
import { Fieldset, Form, Layout } from "@vwfs-bronson/bronson-react";
import * as Validation from "../../validation";
import { FormSection2 } from "./FormSection";
import { DateField } from "../../formik/DateField";

const select = (whitelist, all) => all.filter((v) => whitelist.includes(v.key));

const PersonalSection = ({
  closed,
  success,
  showEditButton,
  onIconClick,
  form,
  buttons,
  containerRef,
}) => {
  return (
    <FormSection2
      containerRef={containerRef}
      title={Output.resolve("pages.applicationForm.panels.personalData.title")}
      subtitle={Output.resolve(
        "pages.applicationForm.panels.personalData.subtitle"
      )}
      success={success}
      expanded={!closed}
      onHeaderClick={onIconClick}
      edit={
        !showEditButton
          ? undefined
          : {
              label: Output.resolve("pages.applicationForm.buttonEdit"),
              onClick: onIconClick,
            }
      }
    >
      <Form {...form} floatingLabel>
        <Fieldset>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                {renderRadioGroup({
                  fieldName: "salutation",
                  legend: Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.salutation.label"
                  ),
                  options: select(
                    ["MRS", "MR"],
                    Output.resolve(
                      "pages.applicationForm.panels.personalData.fields.salutation.values"
                    )
                  ),
                })}
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"title"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.title.label"
                  )}
                  component={SelectField}
                >
                  {toOptions(
                    Output.resolve(
                      "pages.applicationForm.panels.personalData.fields.title.values",
                      []
                    )
                  )}
                </FastField>
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"firstName"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.firstName.label"
                  )}
                  component={TextField}
                />
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"lastName"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.surname.label"
                  )}
                  component={TextField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"maidenName"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.maidenName.label"
                  )}
                  component={TextField}
                />
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"birthDate"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.dateOfBirth.label"
                  )}
                  tooltip={Output.resolveAsMarkdown(
                    "pages.applicationForm.panels.personalData.fields.dateOfBirth.toolTip"
                  )}
                  component={DateField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"placeOfBirth"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.placeOfBirth.label"
                  )}
                  maxLength="30"
                  component={TextField}
                />
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"nationality"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.citizenship.label"
                  )}
                  component={SelectField}
                >
                  {toOptions(Output.resolve("generic.countrylist", []))}
                </FastField>
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"maritalStatus"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.maritalStatus.label"
                  )}
                  component={SelectField}
                >
                  {toOptions(
                    Output.resolve(
                      "pages.applicationForm.panels.personalData.fields.maritalStatus.values",
                      []
                    )
                  )}
                </FastField>
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                {renderRadioGroup({
                  fieldName: "livingStatus",
                  tooltip: Output.resolveAsMarkdown(
                    "pages.applicationForm.panels.personalData.fields.livingTogether.toolTip"
                  ),
                  legend: Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.livingTogether.label"
                  ),
                  options: select(
                    ["yes", "no"],
                    Output.resolve(
                      "pages.applicationForm.panels.personalData.fields.livingTogether.values"
                    )
                  ),
                })}
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name={"fiscalNumber"}
                  label={Output.resolve(
                    "pages.applicationForm.panels.personalData.fields.vatNumber.label"
                  )}
                  tooltip={Output.resolveAsMarkdown(
                    "pages.applicationForm.panels.personalData.fields.vatNumber.toolTip"
                  )}
                  component={TextField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
        </Fieldset>
        <Fieldset>
          <Fieldset.Row>{buttons}</Fieldset.Row>
        </Fieldset>
      </Form>
    </FormSection2>
  );
};

PersonalSection.defaultProps = {
  validate: Validation.select(
    "title",
    "salutation",
    "firstName",
    "lastName",
    "maidenName",
    "birthDate",
    "placeOfBirth",
    "nationality",
    "maritalStatus",
    "livingStatus",
    "fiscalNumber"
  ),
};

export default PersonalSection;
